import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ValueAccessorBase } from '@hutsix/ngxh6';
import { NgControl } from '@angular/forms';

@Component({
    selector: 'app-sf-form-involved',
    templateUrl: './sf-form-involved.component.html',
    styleUrls: ['./sf-form-involved.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SfFormInvolvedComponent extends ValueAccessorBase implements OnChanges {
    public choices = [
        { choice: 'age5to12', label: '5 - 12' },
        { choice: 'age13to18', label: '13 - 18' },
        { choice: 'age19to25', label: '19 - 25' },
        { choice: 'age26to40', label: '26 - 40' },
        { choice: 'age41to60', label: '41 - 60' },
        { choice: 'age61plus', label: '61+' },
    ];

    public inputValue: any = {};

    constructor(
        public cdRef: ChangeDetectorRef,
        public ngControl: NgControl,
    ) {
        super(cdRef, ngControl);
    }

    ngOnChanges(changes: SimpleChanges): void {
        // console.log(this.view.vars);

        super.ngOnChanges(changes);
    }

    minus(choice): void {
        if (this.inputValue[choice]) this.inputValue[choice]--;
        if (!this.inputValue[choice]) this.inputValue[choice] = null;
        this.onInputChange();
    }

    add(choice): void {
        if (!this.inputValue[choice]) this.inputValue[choice] = 0;
        this.inputValue[choice]++;
        this.inputValue = JSON.parse(JSON.stringify(this.inputValue));
        this.onInputChange();
    }

    writeValue(value: any): void {
        if (value === undefined || value === null) value = {};
        super.writeValue(value);
    }
}
